export const DEFAULT_PRODUCT_IMAGE =
  'https://storage.googleapis.com/fz-fashinza-media/default-img-rfq.svg';

export const DEFAULT_VALUE = 'N/A';
